var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"design-home"},[_c('navBarNoLab',{attrs:{"onIndex":5}}),_c('designBackground',{attrs:{"backGroundCom":_vm.backGroundComInfo},scopedSlots:_vm._u([{key:"navList",fn:function(){return [_c('pageElement',{attrs:{"onIndex":5}})]},proxy:true}])}),_c('specialColumn'),_c('richColorful'),_c('teachCompre'),_c('bottomWidge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }